import { render, staticRenderFns } from "./ProvidentFund.vue?vue&type=template&id=20c4ae29&scoped=true&"
import script from "./ProvidentFund.vue?vue&type=script&lang=js&"
export * from "./ProvidentFund.vue?vue&type=script&lang=js&"
import style0 from "./ProvidentFund.vue?vue&type=style&index=0&id=20c4ae29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c4ae29",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VListItemTitle,VRow,VSpacer,VTextField})
